// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_3lTHaGf4x_cqyEkUJdj_Ik"};